import * as UtilBase from './contentHouse-util-base'
export default { ...UtilBase }
